import { getPatternDefForPage } from '@wix/wix-data-client-common/dist/esm/business-logic/dynamic-pages/router-config/routerConfig'
import { truncatePageTitle } from '@wix/wix-data-client-common/dist/esm/business-logic/dynamic-pages/router-config/templates'
import {
  generate as generateRouteDefinition,
  removeSeoMetaTags,
  generateUniquePageRole,
  isEditor3OrStudio2,
} from '@wix/wix-data-client-common'
import { generateUniquePrefix } from '../generateUniquePrefix'
import { prefixTitleWithCopyOf, prefixUrlWithCopyOf } from './prefixWithCopyOf'

const getRouteToDuplicate = async ({ editorSdkProxy, pageRef }) => {
  const routerRef = await editorSdkProxy.document.routers.getByPage({
    pageRef,
  })

  const { config, pages, prefix } = await editorSdkProxy.document.routers.get({
    routerRef,
  })

  const { pattern, def } = getPatternDefForPage(config, pages, pageRef)

  return {
    routeDefinitionBase: def,
    prefix,
    route: pattern,
  }
}

const generatePageTitle = (i18n, originalTitle) => {
  const pageTitle = prefixTitleWithCopyOf(i18n, originalTitle)
  return truncatePageTitle(pageTitle)
}

const generateMenuItemLabel = pageTitle => pageTitle.replace(/ \(All\)$/, '')

export const getDataForNewPage = async ({
  editorSdkProxy,
  i18n,
  pageRef,
  seoV2,
  editorType,
}) => {
  const { prefix, route, routeDefinitionBase } = await getRouteToDuplicate({
    editorSdkProxy,
    pageRef,
  })

  const inputsForPrefix = [prefixUrlWithCopyOf(prefix)]

  const [routerPrefix, pageData] = await Promise.all([
    generateUniquePrefix({
      inputsForPrefix,
      editorSdkProxy,
      ignorePageType: true,
    }),
    editorSdkProxy.document.pages.data.get({ pageRef }),
  ])

  const title = pageData.title.trim()

  const pageTitle = generatePageTitle(i18n, title)

  const menuItemLabel = generateMenuItemLabel(pageTitle)

  const pageRole = isEditor3OrStudio2(editorType)
    ? await generateUniquePageRole({ editorSdkProxy })
    : undefined

  const routeDefinition = generateRouteDefinition({
    routeDefinitionBase,
    pattern: route,
    collectionId: routeDefinitionBase.config.collection,
    seoV2,
    pageRole,
  })

  return {
    route,
    routerPrefix,
    routeDefinition: seoV2
      ? removeSeoMetaTags(routeDefinition)
      : routeDefinition,
    pageTitle,
    menuItemLabel,
  }
}
